// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Error_wrapper__1SoBw","inner":"Error_inner__CFe0D"};